import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from './pages/Main';
import CV from './pages/CV';
import Socials from './pages/Socials';
import Contact from './pages/Contact';
import Research from './pages/Research';
import Projects from './pages/Projects';
import PromptLife2 from './pages/PromptLife2';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/socials" element={<Socials />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/research" element={<Research />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/prompt-life-game" element={<PromptLife2 />} />
      </Routes>
    </Router>
  );
}

export default App;